import { Component, OnInit, Input } from '@angular/core';
import { ProfileTrader } from '../../../state-management/club-trader/trader.reducer';
import { NINETY_DAYS_CATEGORY, ONE_THOUSAND_MS, SIXTY_MS, THIRTY_DAYS_CATEGORY, THREE_MONTHS_CATEGORY, TWENTY_FOUR_MS } from '../../../utils/club-trader-constant';

@Component({
  selector: 'time-in-category',
  templateUrl: './time-in-category.component.html',
  styleUrls: ['./time-in-category.component.scss'],
})
export class TimeInCategoryComponent implements OnInit {
  
  @Input() public profile: ProfileTrader;
  public typeProfileLowerCase: string;
  public unlockTraderDays: number;
  public unblockTraderMonths: string;
  public countToUnblock: number;
  readonly today = new Date();
  readonly msInDay = TWENTY_FOUR_MS * SIXTY_MS * SIXTY_MS * ONE_THOUSAND_MS;
  public inClub: boolean = false;
  public block: string;
  public cssBackground: string;
  public typeTrader: string;
  public svgUnlock: string;

  constructor() {
    /** */
  }

  ngOnInit() {
    this.initializeTime();
  }

  private initializeTime(): void {
  
    this.inClub = !!this.profile.profileInfo.typeProfile && this.profile.profileInfo.typeProfile.toString().indexOf('TRADER') >= 0;
    
    const countDays = this.getDayDiff();
    const countMonths = Math.floor(countDays / THIRTY_DAYS_CATEGORY);
    const countToUnblock = countMonths < THREE_MONTHS_CATEGORY ? NINETY_DAYS_CATEGORY - countDays : 0;
    const countToNext = THIRTY_DAYS_CATEGORY - (countDays % THIRTY_DAYS_CATEGORY);

    this.countToUnblock = countToUnblock;
  
    this.unlockTraderDays = countToUnblock === 0 ? countToNext : countToUnblock;
    this.unblockTraderMonths = countToUnblock === 0 ? `${countMonths} meses` : '3 meses';
    
    try { 
      this.typeTrader = this.getTypeTrader();
      const typeProfile = this.typeTrader === 'vip' ? this.typeTrader.toUpperCase() : `${this.typeTrader[0].toUpperCase()}${this.typeTrader.slice(1)}`;
      this.typeProfileLowerCase = typeProfile;
      this.block = this.getBlock();
      this.cssBackground = this.getCssBackground();
      this.svgUnlock = this.getSvgUnblock();
    } catch {
      this.block = '-block';
      this.typeTrader = '';
      this.cssBackground = '';
      this.svgUnlock = 'stock/assets/icons/padlock.svg';
    }
  }
  

  private getBlock = (): string => this.countToUnblock !== 0 ? '-block' : ''

  private getDayDiff = (): number => this.inClub ? Math.round(Math.abs(Number(this.today) - Number(this.profile.profileInfo.dateEntry)) / this.msInDay) : 0;

  private getTypeTrader = (): string => this.inClub ? this.profile.profileInfo.typeProfile.replace('TRADER_', '').toLocaleLowerCase() : 'starter';

  private getCssBackground = (): string => this.countToUnblock === 0 ? `${this.getTypeTrader()}-back` : '';

  private getSvgUnblock = (): string => {
    if (this.countToUnblock === 0 && (this.profile.profileInfo.typeProfile === 'TRADER_STARTER' || this.profile.profileInfo.typeProfile === 'DEFAULT')) {
      return 'stock/assets/icons/star.svg'
    }else if (this.countToUnblock === 0){
      return 'stock/assets/icons/star_white.svg';
    } else {
      return 'stock/assets/icons/padlock.svg';
    }     
  }

}
